<template>
  <div>

    <form id="user" v-on:submit="save">
      <div class="input-group mb-3">
        <input asp-for="UserName" autocomplete="off" class="form-control" placeholder="Username">
        <div class="input-group-append">
          <div class="input-group-text">
            <span class="fas fa-user"></span>
          </div>
        </div>
      </div>
      <div class="input-group mb-3">
        <input asp-for="Password" autocomplete="off" class="form-control" placeholder="Password">
        <div class="input-group-append">
          <div class="input-group-text">
            <span class="fas fa-lock"></span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <div class="g-recaptcha" data-sitekey="6LeVlaUnAAAAAJVJFKfPWMsA5CQPy9RM6h-S8e7c"></div>
          </div>
        </div>
        <div class="col-8">
          <div class="icheck-primary">
            <input type="checkbox" id="remember" asp-for="RememberMe">
            <label for="remember">
              Remember Me
            </label>
          </div>
        </div>
        <!-- /.col -->
        <div class="col-4">
          <button type="submit" class="btn btn-primary btn-block">Sign In</button>
        </div>

        <div class="col-md-12">
          <span asp-validation-for="UserName" class="text-danger"></span>
        </div>
      </div>

      <p class="mt-3">
        <a asp-action="ForgotPassword" asp-controller="Account">I forgot my password</a>
      </p>

    </form>
  </div>
</template>

<script>
  const axios = require('axios').default;

  export default ({
    //props: {
    //  employeeId: Number,
    //  sendEmp: Function,
    //  sendImg: Function,
    //},
    data() {
      return {
        city: {
          ProvinceID: '',
          DistrictID: 0,
          Name: '',
          Active: true,
        },
        province: [],
        district: [],
      }
    },

    created: function () {
      this.pageLoad();
    },

    methods: {
      pageLoad() {
        var id = 0;
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams) {
          id = Number(urlParams.get('id'));
          var uri = window.location.toString();
          if (uri.indexOf("?") > 0) {
            var clean_uri = uri.substring(0, uri.indexOf("?"));
            window.history.replaceState({}, document.title, clean_uri);
          }
        }

        startReq();
        var vm = this;
        // axios.get('/api/RoleApi/pageLoadCities?id=' + id)
        //     .then(function (res) {
        //         vm.province = res.data.prov;

        //         if (res.data.city) {
        //             vm.district = res.data.district;
        //             vm.city = res.data.city;
        //         }

        //         endReq();
        //     })
        //     .catch(function (error) {
        //         console.log(error);
        //     });
      },

      provinceChange() {
        var vm = this;
        axios.post('/api/RoleApi/loadDistrict?id=' + vm.city.ProvinceID)
          .then(function (response) {
            vm.district = response.data.lst;
          })
      },

      save(e) {
        e.preventDefault();
        var vm = this;
        startReq();
        axios.post('/api/RoleApi/saveCity', {
          obj: vm.city,
        })
          .then(function (res) {
            endReq();
            if (res.data.status) {
              toastr.success("Saved Successfully", "Done");
              vm.clear();
            }
            else {
              toastr.error("Something went wrong", "Error!");
            }
          })
      },

      clear() {
        this.city = {
          ProvinceID: '',
          DistrictID: 0,
          Name: '',
          Active: true,
        };
        this.district = [];
      }

    }
  })</script>

<style>
  .h4-t {
    margin-top: -9px;
    margin-bottom: -5px;
    font-weight: 600
  }

  .h4-c {
    margin-bottom: -5px;
    font-weight: 600
  }
</style>





// WEBPACK FOOTER //
// src/components/login.vue